import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import styles from "./PasswordReset.module.css";
import Logo from "../../Assets/Images/readPro_logo.png";
import background from "../../Assets/Images/background.svg";
import PasswordInput from "../../Components/Password/PasswordInput";
import { RiLockPasswordFill } from "react-icons/ri";
import RefreshCaptchIMg from "../../Assets/Images/refresh_captcha_image.svg"
import qs from "qs";

import Logo2 from "../../Assets/Images/ify_logo.png";
import { connect, useDispatch } from "react-redux";

import Loading from "../../Components/Loading/Loading";
import { createCaptcha, createCaptchaV2, resetPassword, resetPasswordMongo } from "../../Services/auth";
import { passwordValidate } from "../../Values/validatorsnew";
import LogoNew from "../../Assets/Images/IFY_Magicbricks_Logo.png";
import { googleAnalytics } from "../../Services/users";
import PasswordInputWithTooltip from "../../Components/Password/PasswordInputWithTooltip";

type props = {
  history: any;
  firstLogin: boolean;
  user: any;
};

let oobCode: any;
let expiry: any;

const PasswordReset: FunctionComponent<props> = ({ history, firstLogin, user }) => {
  const confirmPasswordRef: any = useRef();
  const passwordRef: any = useRef();
  const dispatcher = useDispatch();
  const [reset, setReset] = useState(false);
  const [load, setLoad] = useState(false);
  const [captchaImageUrl, setCaptchaImageUrl] = useState<string>(""); 
  const[answer,setAnswer]=useState<string>("");
  const [captchaInput, setCaptchaInput] = useState<string>("");
  const [refershCaptcha,setRefershCaptcha] = useState(false);
  const passwordTooltip = (
    <div>
      <strong>Password requirements:</strong>
      <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
        <li>8–20 characters long</li>
        <li>At least one uppercase (A–Z) & lowercase (a–z) letter</li>
        <li>At least one number (0–9)</li>
        <li>At least one special character (@, $, !, %, *, #, ?, &)</li>
        <li>No spaces allowed</li>
      </ul>
    </div>
  );


  const Reset = async (password: string, confirmPassword: string) => {
    resetPasswordMongo(
      password,
      confirmPassword,
      dispatcher,
      oobCode,
      expiry,
      (value) => setLoad(value),
      (val) => setReset(val),
      firstLogin,
      history,
      user,
      (value) => setRefershCaptcha(value),
      answer,
      captchaInput,
    );
  };

    useEffect(()=>{
      setRefershCaptcha(false)
      genereteCaptcha();
    },[refershCaptcha])

  

    const genereteCaptcha = ()=> {
      createCaptchaV2(
        (value)=>{setCaptchaImageUrl(value)},
        (value)=>{setAnswer(value)},
        dispatcher
      );
    }

      // const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      //   const value = e.target.value;
      //   // Allow numbers between 1 and 9, and the '-' symbol
      //   if (/^-?[0-9]*$/.test(value)) {
      //       setCaptchaInput(value);  // Update state with valid input
      //   }

  useEffect(() => {
    const data = qs.parse(history.location.search, { ignoreQueryPrefix: true });
    if (data.oobCode === undefined) {
      if (firstLogin !== true) {
        history.push("/");
      }
    }

    oobCode = data.oobCode;
    expiry = data.ts
  }, [history, firstLogin]);
  useEffect(()=>{
    googleAnalytics('First_Login_Password_Reset_Screen')
  },[])
  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "no-repeat",
        width: "100%",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundColor: "rgba(0, 0, 0, 0.02)",
      }}
      className={styles.parent}
    >
      {load === true && <Loading />}
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <img
            src={LogoNew}
            alt={"top"}
            className={styles.image}
            width={"150vw"}
          />
          <p className={styles.welcome}>Welcome,</p>
          <p className={styles.text}>Reset Password for your Your Account.</p>
        </div>
        {reset === true ? (
          <>
            <p className={styles.completeText}>Password Reset Successfully</p>
          </>
        ) : (
          <div className={styles.inputContainer}>
            <div className={styles.form}>
              <div className={styles.input}>
                <PasswordInputWithTooltip
                  title={"Password"}
                  ref={passwordRef}
                  validator={passwordValidate}
                  tooltiptext={passwordTooltip}
                >
                  <RiLockPasswordFill color={"#808080"} />
                </PasswordInputWithTooltip>
              </div>

              <div className={styles.input}>
                <PasswordInput
                  title={"Confirm Password"}
                  ref={confirmPasswordRef}
                  validator={passwordValidate}
                  onPress={() =>
                    Reset(
                      passwordRef.current?.value,
                      confirmPasswordRef.current?.value
                    )
                  }
                >
                  <RiLockPasswordFill color={"#808080"} />
                </PasswordInput>
              </div>
              <div className={styles.captcha}>
                <img src={captchaImageUrl} className={styles.captchaImg} alt="Captch" />
                <div className={styles.captchaRefresh} onClick={genereteCaptcha}>
                  <div><img src={RefreshCaptchIMg} alt="refresh" /></div>
                  Refresh
                </div>
                
                <div>
                  <input
                    className={styles.captchaInput}
                    type="text"
                    placeholder="Enter CAPTCHA"
                    value={captchaInput}
                    onChange={(e)=>{setCaptchaInput(e.target.value)}}
                    style={{textAlign:"center",fontSize:"30"}}
                  />
                </div>
              </div>
            </div>
            <div className={styles.buttonView}>
              <button
                className={styles.button}
                onClick={() =>
                  Reset(
                    passwordRef.current?.value,
                    confirmPasswordRef.current?.value
                  )
                }
              >
                Reset
              </button>
            </div>
          </div>
        )}

        {/* <div className={styles.bottomView}>
          <p className={styles.bottomText}>POWERED BY</p>
          <img src={Logo2} alt={"bottom "} width={"150vw"} />
        </div> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    firstLogin: state.user.firstLogin,
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(PasswordReset);
